import Button from '@/components/UI/Button';
import { dueDiligenceList } from '@/constants/Rover/Applications';
import type { ApplicationPhaseType } from '@/types/ClientApplication';

const ApplicationNavBar = ({
  selectedDueDiligence,
  setSelectedDueDiligence,
}: {
  selectedDueDiligence: { label: string; value: ApplicationPhaseType };
  setSelectedDueDiligence: React.Dispatch<React.SetStateAction<{ label: string; value: ApplicationPhaseType }>>;
}) => {
  const handleDueDiligence = (d: { label: string; value: ApplicationPhaseType }) => {
    setSelectedDueDiligence(d);
  };
  return (
    <div className='flex justify-between w-full items-start p-6 bg-white'>
      <div className='flex gap-3'>
        {dueDiligenceList.map((d: { label: string; value: ApplicationPhaseType }) => (
          <Button
            key={d?.value}
            label={d?.label}
            customClassName={`${d.value !== selectedDueDiligence.value && 'border-2 rounded'}`}
            btnStyle={`${d.value === selectedDueDiligence.value ? 'btn-primary' : 'btn-neutral'}`}
            btnType='button'
            onClick={() => handleDueDiligence(d)}
          />
        ))}
      </div>
    </div>
  );
};

export default ApplicationNavBar;
